<template>
  <v-row no-gutters class="map-zoom-level my-0 pa-1 px-2">
    {{ `${$i18n.t('default.zoomLevel')}: ${computedZoomLevel}` }}
  </v-row>
</template>
<script>
export default {
  props: {
    zoomLevel: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    computedZoomLevel() {
      return Number.parseInt(this.zoomLevel);
    }
  }
};
</script>
<style lang="scss" scoped>
.map-zoom-level {
  background-color: rgba(0, 60, 136, 0.3);
  border-radius: 4px;
  color: #eee;
  font-size: 12px;
  position: absolute;
  z-index: 4;
  left: 12px;
  bottom: 40px;
}
</style>